import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import { Alert } from "reactstrap";
import Select from "react-select";
import { addNewPayment } from "store/Payment/actions";
import { getcitylist } from "store/participantcity/actions";
import { getdistrictlist } from "store/participantdistrict/actions";
import { getprovincelist } from "store/participantprovince/actions";
import { getdesignationlist } from "store/participantdesignation/actions";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
} from "store/registration-admin/actions";
import { getParticipantSchemelist } from "store/Payment/actions";
import { getcyclelist } from "store/cycle/actions";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

//Import Breadcrumb
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getAllLabs,
  updateAllLabs,
  approveUnapproveLab,
} from "store/registration-admin/actions";

import ApproveUnapproveModal from "components/Common/ApproveUnapproveModal";
import "assets/scss/table.scss";
import moment from "moment";

class PendingLabs extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.handleSchemeChange = this.handleSchemeChange.bind(this);
    this.handleSchemeModalOpen = this.handleSchemeModalOpen.bind(this);
    this.handleSchemeModalClose = this.handleSchemeModalClose.bind(this);
    this.state = {
      AllLabs: [],
      approvedLabs: [],
      ListCity: [],
      ListDistrict: [],
      ListProvince: [],
      ListDesignation: [],
      selectedProvince: "",
      CycleList: [],
      ListCity: [],
      selectedProvince: "",
      provinceOptions: [],
      ListDistrict: [],
      ListProvince: [],
      ListDesignation: [],
      ListDepartment: [],
      ListCountry: [],
      ListType: [],
      ListSector: [],
      CycleList: [],
      selectedScheme: null,
      id: "",
      btnText: "Copy",
      isPaymentModalOpen: false,
      isMembershipModalOpen: false,
      organization_name: "",
      selectedSchemeCount: "",
      isApproved: false,
      unapprovedModal: false,
      tooltipContent: ["Worst", "Bad", "Average", "Good", "Excellent"],
      filteredLabs: [],
      cityOptions: [],
      districtOptions: [],
      selectedParticipantType: "All Participant",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      pendingLabListColumns: [
        {
          dataField: "registered_at",
          text: "Joining Date",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, row) => (
            <>
              {row.registered_at
                ? moment(row.registered_at).format("DD MMM YY")
                : "-"}
            </>
          ),
        },
        {
          dataField: "district",
          text: "District",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.district}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "city",
          text: "City",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.city}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "name",
          text: "Participant",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <Link
                  to="#"
                  onClick={(e) => this.openLabModal(e, row)}
                  style={{
                    cursor: "pointer",
                    color: isPart ? "#c20505ff" : "#007bff", // black if red row, else default blue
                  }}
                >
                  {row.name}
                </Link>
              </span>
            );
          },
        },
        {
          dataField: "lab_staff_name",
          text: "Name",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.lab_staff_name}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "landline_registered_by",
          text: "Contact No.",
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.landline_registered_by}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "schemes",
          text: "Scheme",
          sort: true, // ✅ Enable sorting
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
            cursor: "pointer",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          formatter: (cellContent, lab) => {
            const activeCycleIds = new Set(
              (this.state.CycleList || [])
                .filter((c) => c.status?.toLowerCase() === "active")
                .map((c) => String(c.id)),
            );
            const count = Array.isArray(lab.schemes)
              ? lab.schemes.filter((s) =>
                  activeCycleIds.has(String(s.cycle_id)),
                ).length
              : 0;
            return (
              <Link
                to="#"
                onClick={() => this.handleSchemeModalOpen(lab)}
                style={{ fontWeight: "bold", textDecoration: "underline" }}
              >
                {count > 0 ? `${count}` : "-"}
              </Link>
            );
          },
          sortFunc: (a, b, order) => {
            const activeCycleIds = new Set(
              (this.state.CycleList || [])
                .filter((c) => c.status?.toLowerCase() === "active")
                .map((c) => String(c.id)),
            );
            const countA = Array.isArray(a)
              ? a.filter((s) => activeCycleIds.has(String(s.cycle_id))).length
              : 0;
            const countB = Array.isArray(b)
              ? b.filter((s) => activeCycleIds.has(String(s.cycle_id))).length
              : 0;
            if (order === "asc") return countA - countB;
            return countB - countA;
          },
          filter: textFilter({
            onFilter: (filterValue, data) => {
              const count = parseInt(filterValue, 10);
              if (isNaN(count)) return data;
              const activeCycleIds = new Set(
                (this.state.CycleList || [])
                  .filter((c) => c.status?.toLowerCase() === "active")
                  .map((c) => String(c.id)),
              );
              return data.filter(
                (row) =>
                  Array.isArray(row.schemes) &&
                  row.schemes.filter((s) =>
                    activeCycleIds.has(String(s.cycle_id)),
                  ).length === count,
              );
            },
          }),
          sortFunc: (a, b, order) => {
            const countA = Array.isArray(a) ? a.length : 0;
            const countB = Array.isArray(b) ? b.length : 0;
            if (order === "asc") {
              return countA - countB;
            }
            return countB - countA;
          },
          filter: textFilter({
            onFilter: (filterValue, data) => {
              const count = parseInt(filterValue, 10); // convert input to number
              if (isNaN(count)) return data; // if input is not a number, return all
              return data.filter(
                (row) =>
                  Array.isArray(row.schemes) && row.schemes.length === count,
              );
            },
          }),
        },
        {
          dataField: "type",
          text: "Lab Type",
          skipDefaultStyles: true,
          headerStyle: {
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return { color: "#c20505ff", textAlign: "center" };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, row) => (
            <span
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              {row.type || "–"}
            </span>
          ),
        },

        {
          dataField: "sector",
          text: "Sector",
          headerStyle: {
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return { color: "#c20505ff", textAlign: "center" };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, row) => (
            <span
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              {row.sector || "–"}
            </span>
          ),
        },
        // {
        //   dataField: "payment_settlement",
        //   text: "Payment Settlement",
        //   skipDefaultStyles: true,
        //   headerStyle: {
        //     backgroundColor: "#d0e2ff",
        //     textAlign: "center",
        //   },
        //   style: (cell, row) => {
        //     const isPart =
        //       row.payment_settlement?.toString().toLowerCase() === "part";

        //     if (isPart) {
        //       return {
        //         // backgroundColor: "#c20505ff",
        //         color: "#c20505ff",
        //         textAlign: "center",
        //       };
        //     }

        //     return { backgroundColor: "#d0e2ff", textAlign: "center" };
        //   },
        //   filter: textFilter(),
        //   sort: true,
        //   formatter: (cellContent, row) => {
        //     const settlement = (
        //       row.payment_settlement ??
        //       row.payment?.settlement ??
        //       ""
        //     )
        //       .toString()
        //       .trim();

        //     const remaining = row.remaining_amount ?? "-";

        //     // Format remaining amount with commas
        //     const formattedRemaining =
        //       remaining && !isNaN(remaining)
        //         ? Number(remaining).toLocaleString()
        //         : "–";

        //     const displayText = `${
        //       settlement && settlement !== "--" ? settlement : "–"
        //     }${
        //       settlement === "Part" ? ` (Remaining: ${formattedRemaining})` : ""
        //     }`;

        //     return (
        //       <div
        //         style={{
        //           display: "flex",
        //           flexDirection: "column",
        //           alignItems: "flex-end",
        //           color: settlement === "Part" ? "#c20505ff" : "black",
        //         }}
        //         title={displayText} // <-- tooltip on hover
        //       >
        //         <span>
        //           {settlement && settlement !== "--" ? settlement : "–"}
        //         </span>
        //         {settlement === "Part" && (
        //           <span
        //             style={{
        //               fontSize: "0.85em",
        //               color: "#c20505ff",
        //             }}
        //           >
        //             {formattedRemaining}
        //           </span>
        //         )}
        //       </div>
        //     );
        //   },
        // },

        // {
        //   dataField: "payment_status",
        //   text: "Payment Status",
        //   skipDefaultStyles: true,
        //   headerStyle: {
        //     backgroundColor: "#d0e2ff",
        //     textAlign: "center",
        //   },
        //   style: (cell, row) => {
        //     const isPart =
        //       row.payment_settlement?.toString().toLowerCase() === "part";

        //     if (isPart) {
        //       // Let rowStyle color show (no override)
        //       return {
        //         // backgroundColor: "#c20505ff",
        //         color: "#c20505ff",
        //         textAlign: "right",
        //       };
        //     }

        //     // Normal case (your original colors)
        //     return { backgroundColor: "#d0e2ff", textAlign: "right" };
        //   },
        //   filter: textFilter(),
        //   sort: true,
        //   formatter: (cellContent, row) => {
        //     const value = (row.payment_status ?? row.payment?.status ?? "")
        //       .toString()
        //       .trim();
        //     if (!value || value === "--") return <span>–</span>;
        //     return <span>{value}</span>;
        //   },
        // },

        {
          dataField: "membership_status",
          text: "Membership",
          // skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllLabs) => {
            // Assuming the cycle status is stored in AllLabs.cycle_status or similar
            const cycleStatus = AllLabs.cycle_status || ""; // adjust if your key is different

            const displayStatus =
              cycleStatus.toLowerCase() === "active"
                ? "Active"
                : AllLabs.membership_status
                ? AllLabs.membership_status
                : "Inactive";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {displayStatus}
              </span>
            );
          },
          filter: textFilter(),
        },
        {
          dataField: "data",
          text: "id",
          isDummyField: true,
          editable: false,
          text: "Action",
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";

            if (isPart) {
              // Let rowStyle color show (no override)
              return {
                // backgroundColor: "#e01515ff",
                color: "white",
                textAlign: "right",
              };
            }

            // Normal case (your original colors)
            return { backgroundColor: "#d0e2ff", textAlign: "right" };
          },
          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {/* Existing Payment Icon */}
                <Tooltip title="Payment">
                  <Link
                    to={{
                      pathname:
                        AllLabs.payment_settlement?.toString().toLowerCase() ===
                        "part"
                          ? `/${this.state.organization_name}/partialpayment/${AllLabs.id}` // Partial
                          : `/${this.state.organization_name}/csrAllpartcicpantpaymentmodal/${AllLabs.id}`, // Full
                      state: { selectedParticipant: AllLabs },
                    }}
                  >
                    <i className="fas fa-money-bill-wave"></i>
                  </Link>
                </Tooltip>
                <Tooltip title="History">
                  <Link
                    className="fas fa-comment font-size-18"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const url = `/${this.state.organization_name}/Participant-History/${AllLabs.id}`;
                      this.props.history.push(url);
                    }}
                  ></Link>
                </Tooltip>
                {/* NEW ICON — Only show when status = "part"
                {AllLabs.payment_settlement?.toString().toLowerCase() ===
                  "part" && (
                  <Tooltip title="Partial Payment">
                    <Link
                      to={{
                        pathname: `/${this.state.organization_name}/partialpayment/${AllLabs.id}`,
                        state: { selectedParticipant: AllLabs },
                      }}
                    >
                      <i className="mdi mdi-cash-refund"></i>
                    </Link>
                  </Tooltip>
                )} */}
              </div>
            </>
          ),
        },
      ],
    };
    console.log(
      "Initialized user_id:",
      localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "No authUser found in localStorage",
    );

    this.toggle = this.toggle.bind(this);
    this.handleApprovedEvent = this.handleApprovedEvent.bind(this);
    this.togglePatientModal = this.togglePatientModal.bind(this);
    this.toggleMarketerModal = this.toggleMarketerModal.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleParticipantTypeChange =
      this.handleParticipantTypeChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    // After this.state = { ... }
  }

  isPaymentModalOpen = (participant) => {
    this.setState(
      {
        isPaymentModalOpen: true,
        selectedParticipant: participant, // Store full participant object
      },
      () => console.log("Modal State Updated:", this.state.selectedParticipant),
    );
  };

  isMembershipModalOpen = (participant) => {
    console.log("Opening Membership Modal for Participant:", participant); // Debug log
    this.setState(
      {
        isMembershipModalOpen: true,
        selectedParticipant: participant, // Store the correct participant
      },
      () =>
        console.log(
          "Membership Modal Opened for:",
          this.state.selectedParticipant,
        ),
    );
  };
  handleSchemeCountChange = (e) => {
    const selectedSchemeCount = e.target.value;
    this.setState({ selectedSchemeCount }, () => {
      this.applyFilters();
    });
  };

  getMaxSchemeCount = () => {
    const { AllLabs } = this.state;

    if (!Array.isArray(AllLabs)) return 0;

    let max = 0;
    AllLabs.forEach((lab) => {
      const count = Array.isArray(lab.schemes) ? lab.schemes.length : 0;
      if (count > max) max = count;
    });

    return max;
  };
  handleParticipantTypeChange(event) {
    const selectedParticipantType = event.target.value;
    console.log("Selected Participant Type:", selectedParticipantType);

    this.setState({ selectedParticipantType }, () => {
      console.log(
        "Updated selectedParticipantType in state:",
        this.state.selectedParticipantType,
      );
      this.applyFilters();
    });
  }

  handleSchemeChange = (event) => {
    const selectedScheme = event.target.value;
    console.log("Scheme selected:", selectedScheme);

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
    const { organization_name } = this.state; // Extract from state
  };
  handleSchemeModalOpen(lab) {
    const cycleList = this.state.CycleList || [];

    const schemesWithRounds = (lab.schemes || []).map((scheme) => {
      const matchedCycle = cycleList.find(
        (cycle) => String(cycle.id) === String(scheme.cycle_id),
      );

      const rawStatus = matchedCycle ? matchedCycle.status : null;
      const formattedStatus = rawStatus
        ? rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase()
        : "–";

      return {
        ...scheme,
        round_numbers: matchedCycle ? matchedCycle.round_numbers : "–",
        reportstatus: matchedCycle ? matchedCycle.reportstatus : null,
        cycle_status: formattedStatus, // ← add this
      };
    });

    this.setState({
      showSchemeModal: true,
      selectedSchemes: schemesWithRounds,
      selectedParticipant: lab,
    });
  }
  handleSchemeModalClose() {
    this.setState({
      showSchemeModal: false,
      selectedSchemes: [],
      selectedParticipant: null,
    });
  }
  applyFilters = () => {
    const {
      AllLabs,
      selectedParticipantType,
      selectedScheme,
      selectedCycle,
      selectedProvince,
      organization_name,
    } = this.state;

    console.log("Filtering with:", {
      selectedParticipantType,
      selectedScheme,
      selectedCycle,
      selectedProvince,
      AllLabs,
    });

    const filteredData = AllLabs.filter((lab) => {
      const membershipStatus = lab.membership_status?.trim().toLowerCase();
      const membershipDetail = lab.membership_status_detail
        ? lab.membership_status_detail.trim().toLowerCase()
        : ""; // Default to empty string if undefined

      console.log("Lab Data:", {
        id: lab.id,
        membershipStatus,
        membershipDetail,
      });

      // Define the condition for each participant type
      let matchesParticipantType = false;

      if (selectedParticipantType === "All Participant") {
        matchesParticipantType = true; // Show all participants
      } else if (selectedParticipantType === "Approved Participant") {
        matchesParticipantType =
          membershipStatus === "active" || membershipDetail === "active"; // Approved or Active participants
      } else if (selectedParticipantType === "Pending Participant") {
        matchesParticipantType = membershipStatus === "pending"; // Pending participants
      } else if (selectedParticipantType === "Unapproved Participant") {
        matchesParticipantType = membershipStatus === "inactive"; // Only participants with "inactive" membership status
      } else if (selectedParticipantType === "Suspended Participant") {
        matchesParticipantType = membershipStatus === "suspended"; // Suspended participants
      } else if (selectedParticipantType === "New Register") {
        matchesParticipantType = membershipStatus === "new register";
      }

      console.log(
        `Lab ${lab.id} matchesParticipantType:`,
        matchesParticipantType,
      );
      const matchesProvince =
        !this.state.selectedProvince ||
        (lab.province &&
          lab.province.toLowerCase() ===
            this.state.selectedProvince.toLowerCase());

      // 🧠 Match selected scheme
      const matchesScheme =
        !selectedScheme ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            (s) =>
              String(s.scheme_id) === String(selectedScheme) ||
              String(s.scheme_name) === String(selectedScheme),
          ));
      // 🧩 Match selected cycle (only when selected)
      const matchesCycle =
        !selectedCycle ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            (s) => s.cycle_id?.toString() === selectedCycle.toString(),
          ));

      // ✅ Return labs that match all filters
      // NEW FILTER — scheme count
      const matchesSchemeCount =
        !this.state.selectedSchemeCount ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.length === parseInt(this.state.selectedSchemeCount));
      return (
        matchesParticipantType &&
        matchesScheme &&
        matchesCycle &&
        matchesSchemeCount &&
        matchesProvince
      );
    });

    console.log("Filtered Data:", filteredData);

    // Special handling for "Pending Participant"
    if (selectedParticipantType === "Pending Participant") {
      this.props.history.push(`/${organization_name}/CSRPendinglabs`);
      return; // Stop here; no need to update filteredLabs for Pending Participants
    }

    // Update the filtered list in the state for other participant types
    this.setState({ filteredLabs: filteredData }, () => {
      console.log("Updated filteredLabs:", this.state.filteredLabs);
    });
  };

  applyFiltersFromQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const filterType = queryParams.get("filterType");
    const filterValue = queryParams.get("filterValue");

    console.log("Applying filters from query params:", {
      filterType,
      filterValue,
    });

    if (filterType && filterValue) {
      // Update the state based on query parameters
      this.setState(
        {
          selectedParticipantType: filterValue, // Set selected type in state
        },
        () => {
          this.applyFilters(); // Apply filters after updating the state
        },
      );
    }
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  toggleMembershipModal = () => {
    this.setState(
      (prevState) => ({
        isMembershipModalOpen: !prevState.isMembershipModalOpen,
      }),
      () => {
        console.log(
          "Modal Toggled, New State:",
          this.state.isMembershipModalOpen,
        );
      },
    );
  };
  togglePaymentModal = () => {
    this.setState(
      (prevState) => ({
        isPaymentModalOpen: !prevState.isPaymentModalOpen,
      }),
      () => {
        console.log("Modal Toggled, New State:", this.state.isPaymentModalOpen);
      },
    );
  };

  handleEditSubmit(values) {
    console.log("Form values:", values);

    const updatedData = {
      id: values.id,
      name: values.name,
      email: values.email,
      address: values.address,
      province: values.province, // ✅ Add this line
      designation: values.designation,
      shipping_address: values.shipping_address,
      billing_address: values.billing_address,
      marketer_name: values.marketer_name,
      city: values.city,
      district: values.district,
      lab_staff_name: values.lab_staff_name,
      designation: values.designation,
      email_participant: values.email_participant,
      landline_registered_by: values.landline_registered_by,
      payment_status: values.payment_status,
      payment_settlement: values.payment_settlement,
    };

    this.props.onupdateAllLabs(updatedData); // Dispatch update action

    // Show success message
    this.setState({ successMessage: "Participant updated successfully" });

    // Delay modal close by 2 seconds
    setTimeout(() => {
      this.setState({ editModal: false, successMessage: "" });
    }, 2000);
  }

  componentDidMount() {
    console.log("Fetching data...");

    const { onGetCityList } = this.props;
    onGetCityList(this.state.user_id);

    const { onGetDistrictList } = this.props;
    onGetDistrictList(this.state.user_id);

    const { onGetProvinceList } = this.props;
    onGetProvinceList(this.state.user_id);

    const { onGetdesignationlist } = this.props;
    onGetdesignationlist(this.state.user_id);
    // Retrieve user_id from localStorage
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      console.error("User ID is missing. Cannot proceed with API calls.");
      return;
    }

    console.log("Retrieved user_id:", user_id);

    // Set user_id in state
    this.setState({ user_id }, () => {
      // Get organization_name from URL params
      const { organization_name } = this.props.match.params || {};
      console.log("organization_name from props:", organization_name);

      if (organization_name) {
        this.setState({ organization_name }, () => {
          console.log("Organization name set:", this.state.organization_name);

          // // Initialize dropdown value
          // this.setInitialDropdownValue();
          this.fetchData(this.state.user_id);
          this.applyFiltersFromQueryParams();
          // Fetch city options

          this.fetchData(user_id);
        });
      } else {
        console.error("Organization name is missing in URL parameters.");
      }
    });
  }

  handleSchemeSelect = (e) => {
    const selectedScheme = e.target.value;

    // If user selects empty (Select Scheme)
    if (!selectedScheme) {
      this.setState({
        selectedScheme: null,
        showCycleFilter: false,
        selectedCycle: null,
        filteredCycleOptions: [],
        filteredLabs: this.state.AllLabs, // <-- RESET TABLE DATA HERE
      });
      return;
    }

    // If a scheme is selected → continue normal logic
    const filteredCycleOptions = this.state.CycleList.filter(
      (cycle) => String(cycle.scheme_id) === String(selectedScheme),
    );

    this.setState(
      {
        selectedScheme,
        filteredCycleOptions,
        showCycleFilter: true,
        selectedCycle: null,
      },
      () => {
        this.applyFilters(); // <-- Apply your existing filters
      },
    );
  };

  handleCycleSelect = (e) => {
    const selectedCycle = e.target.value;
    this.setState({ selectedCycle }, () => {
      console.log("Selected Scheme:", this.state.selectedScheme);
      console.log("Selected Cycle:", this.state.selectedCycle);
      this.applyFilters();
    });
  };
  // New method to fetch cities

  // Fetch all required data
  fetchData(user_id) {
    const {
      onGetParticipantPayment,
      ongetApprovedLabs,
      ongetcyclelist,
      onGetPendingLabs,
    } = this.props;

    // Call participant payment API
    onGetParticipantPayment(user_id);
    console.log("onGetParticipantPayment called with user_id:", user_id);

    // Call approved labs API
    ongetApprovedLabs(user_id);
    console.log("ongetApprovedLabs called with user_id:", user_id);

    // Call cycle list API
    ongetcyclelist(user_id);
    console.log("ongetcyclelist called with user_id:", user_id);

    // Call pending labs API
    onGetPendingLabs(user_id);
    console.log("onGetPendingLabs called with user_id:", user_id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.ListCity !== this.props.ListCity) {
      this.setState({ ListCity: this.props.ListCity });
    }
    if (prevProps.ListDistrict !== this.props.ListDistrict) {
      this.setState({ ListDistrict: this.props.ListDistrict });
    }
    if (prevProps.ListProvince !== this.props.ListProvince) {
      this.setState({ ListProvince: this.props.ListProvince });
    }
    if (prevProps.ListDesignation !== this.props.ListDesignation) {
      this.setState({ ListDesignation: this.props.ListDesignation });
    }
    if (prevState.filteredLabs !== this.state.filteredLabs) {
      console.log("FilteredLabs updated:", this.state.filteredLabs);
    }
    if (prevProps.approvedLabs !== this.props.approvedLabs) {
      // Logic for approvedLabs if needed
    }
    if (prevProps.CycleList !== this.props.CycleList) {
      console.log("Updating CycleList in state:", this.props.CycleList);
      this.setState({ CycleList: this.props.CycleList });
    }
    if (prevProps.CSRList !== this.props.CSRList) {
      console.log("CSRList prop updated:", this.props.CSRList);
      console.log("CSRList length:", this.props.CSRList?.length);
    }
    if (prevProps.PaymentSchemeList !== this.props.PaymentSchemeList) {
      this.setState({ PaymentSchemeList: this.props.PaymentSchemeList });
      console.log(
        "PaymentSchemeList prop updated:",
        this.props.PaymentSchemeList,
      ); // 👈 NEW
    }
    if (prevProps.AllLabs !== this.props.AllLabs) {
      console.log("Updated AllLabs:", this.props.AllLabs);
      this.setState({ AllLabs: this.props.AllLabs }, () => {
        console.log("State AllLabs updated:", this.state.AllLabs);
        this.applyFilters();
      });
    }
    if (prevProps.AllLabs !== this.props.AllLabs) {
      // Extract unique provinces from API
      const provinces = [
        ...new Set(
          (this.props.AllLabs || []).map((lab) => lab.province).filter(Boolean),
        ),
      ];

      this.setState(
        {
          AllLabs: this.props.AllLabs,
          provinceOptions: provinces,
        },
        () => {
          this.applyFilters();
        },
      );
    }
    if (
      prevProps.AllLabs !== this.props.AllLabs ||
      prevProps.CycleList !== this.props.CycleList
    ) {
      console.log("Filtering CycleList for participants");

      // Extract unique scheme names from AllLabs
      const participantSchemes = new Set(
        this.props.AllLabs.flatMap(
          (lab) => lab.schemes?.map((scheme) => scheme.scheme_name) || [],
        ),
      );

      // Generate the filtered list for participant dropdown
      const filteredCycleList = this.props.CycleList.filter((cycle) =>
        participantSchemes.has(cycle.scheme_name),
      );

      // Update state with both lists
      this.setState({
        CycleList: this.props.CycleList, // Original list for payment modal
        filteredCycleList, // Filtered list for participant filters
      });
    }
  }

  openPatientModal = (e, arg) => {
    this.setState({
      PatientModal: true,
      email: arg.email,
      landline_registered_by: arg.landline_registered_by,
    });
  };

  toggleEditModal = (participant = null) => {
    this.setState(
      (prev) => ({
        editModal: !prev.editModal,
        selectedParticipant: participant || prev.selectedParticipant,
        showModal: participant ? true : !prev.showModal,
      }),
      () => {
        // If modal is now closed, refresh data
        if (!this.state.editModal) {
          this.fetchData(this.state.user_id);
        }
      },
    );
  };
  toggleLabModal = () => {
    this.setState((prevState) => ({
      LabModal: !prevState.LabModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  toggleModal = () => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  };
  openLabModal = (e, arg) => {
    this.setState({
      LabModal: true,
      name: arg.name,
      email: arg.email,
      shipping_address: arg.shipping_address,
      lab_code: arg.lab_code,
      password_foradmins: arg.password_foradmins,
      billing_address: arg.billing_address,
    });
  };
  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  togglePatientModal = () => {
    this.setState((prevState) => ({
      PatientModal: !prevState.PatientModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  openMarketerModal = (e, arg) => {
    this.setState({
      MarketerModal: true,
      marketer_name: arg.marketer_name,
      marketer_phone: arg.marketer_phone,
    });
  };
  toggleMarketerModal = () => {
    this.setState((prevState) => ({
      MarketerModal: !prevState.MarketerModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  handleApprovedEvent = (id) => {
    this.setState({ id: id, isApproved: true, unapprovedModal: true });
  };

  handleUnapprovedEvent = (id) => {
    this.setState({ id: id, isApproved: false, unapprovedModal: true });
  };

  callOnApproveUnapproveLab = () => {
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;

    const data = {
      id: this.state.user_id,
      labId: this.state.id,
      isApproved: this.state.isApproved,
    };

    // calling to unapprove lab
    onApproveUnapproveLab(data);

    // Calling to update list record
    setTimeout(() => {
      onGetPendingLabs(this.state.user_id);
    }, 1000);

    this.setState({ unapprovedModal: false });
  };

  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  getSchemeCounts = () => {
    const { filteredLabs } = this.state;

    const schemeCounts = {};

    filteredLabs.forEach((lab) => {
      if (Array.isArray(lab.schemes)) {
        lab.schemes.forEach((scheme) => {
          const name = scheme.scheme_name;
          schemeCounts[name] = (schemeCounts[name] || 0) + 1;
        });
      }
    });

    return schemeCounts;
  };
  refreshPage = () => {
    // call your API or reload data
    this.fetchData(this.state.user_id);
    this.applyFilters();
  };
  render() {
    console.log("Rendering table with data:", this.state.filteredLabs);
    const { SearchBar } = Search;
    const { ListCity } = this.state;
    const { ListDistrict } = this.state;
    const { ListProvince } = this.state;
    const { ListDesignation } = this.state;
    const schemeCounts = this.getSchemeCounts();
    const cityOptions = ListCity.map((city) => ({
      value: city.name,
      label: city.name,
    }));
    const districtOptions = ListDistrict.map((district) => ({
      value: district.name,
      label: district.name,
    }));
    const provinceOptions = ListProvince.map((province) => ({
      value: province.name,
      label: province.name,
    }));
    const designationOptions = ListDesignation.map((designation) => ({
      value: designation.name,
      label: designation.name,
    }));

    const { AllLabs } = this.props;
    const data = this.state.data;
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;
    const { isPaymentModalOpen, togglePaymentModal } = this.props;
    const { isMembershipModalOpen, toggleMembershipModal } = this.props;
    const { filteredLabs, selectedParticipantType, selectedScheme } =
      this.state;
    const maxSchemeCount = this.getMaxSchemeCount();
    const schemeCountOptions = Array.from(
      { length: maxSchemeCount },
      (_, i) => i + 1,
    );
    const csrOptions = (this.props.CSRList || []).map((username) => ({
      value: username,
      label: username,
    }));
    console.log("render() - csrOptions built:", csrOptions); // 👈 NEW
    const pageOptions = {
      sizePerPage: 50,
      totalSize: AllLabs.length, // replace later with size(AllLabs),
      custom: true,
    };

    // const { isPaymentModalOpen } = this.state;
    const { approvedLabs, CycleList } = this.state;

    const participantOptions = (this.props.approvedLabs || []).map(
      (participant) => ({
        value: participant.id, // ensure this is the correct unique identifier
        label: participant.name, // or any other field you'd like to display
      }),
    );
    const schemeOptions = CycleList.filter(
      (scheme) => scheme.status && scheme.status.toLowerCase() === "active",
    ).map((scheme) => ({
      value: `${scheme.scheme_id}-${scheme.id}`,
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
      scheme_id: scheme.scheme_id,
      cycle_id: scheme.id,
    }));

    console.log("Mapped scheme option:", schemeOptions);
    const { isModalOpen, toggleModal, isOpen, toggle, onSubmit } = this.state;
    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];
    const customStyles = {
      // <-- This is invalid here
      control: (provided) => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Pending Labs | External QC</title>
          </MetaTags>

          <ApproveUnapproveModal
            show={this.state.unapprovedModal}
            onYesClick={this.callOnApproveUnapproveLab}
            onCloseClick={() => this.setState({ unapprovedModal: false })}
          />

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="Lists of Participants" />
            <Row className="mb-2">
              <Col sm="12">
                <p
                  style={{
                    fontSize: "14px",
                    color: "#000000",
                    marginLeft: "10px",
                    marginBottom: "4px",
                  }}
                >
                  <strong>Note:</strong> Scheme count in the table reflects only{" "}
                  <strong>Active Cycle</strong> schemes. Click the count to view
                  full details including all cycles.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.pendingLabListColumns}
                      data={this.state.filteredLabs}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.pendingLabListColumns}
                          data={this.state.filteredLabs}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="12">
                                  <div className="ms-2 mb-4">
                                    <div className="container">
                                      {/* Row 1: Main Filters */}
                                      <div className="row align-items-center mb-3">
                                        {/* Col 1: Participant Type Filter */}
                                        <div className="col-3">
                                          <select
                                            className="form-select"
                                            onChange={
                                              this.handleParticipantTypeChange
                                            }
                                            value={
                                              this.state.selectedParticipantType
                                            }
                                          >
                                            <option value="All Participant">
                                              All Participant
                                            </option>
                                            <option value="Approved Participant">
                                              Approved Participant
                                            </option>
                                            <option value="Unapproved Participant">
                                              Unapproved Participant
                                            </option>
                                            <option value="Pending Participant">
                                              Pending Participant
                                            </option>
                                            <option value="Suspended Participant">
                                              Suspended Participant
                                            </option>
                                          </select>
                                        </div>

                                        {/* Col 2: Province Filter */}
                                        <div className="col-3">
                                          <select
                                            className="form-select"
                                            value={this.state.selectedProvince}
                                            onChange={(e) => {
                                              this.setState(
                                                {
                                                  selectedProvince:
                                                    e.target.value,
                                                },
                                                () => {
                                                  this.applyFilters();
                                                },
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Select Province
                                            </option>
                                            {this.state.provinceOptions.map(
                                              (prov, i) => (
                                                <option key={i} value={prov}>
                                                  {prov}
                                                </option>
                                              ),
                                            )}
                                          </select>
                                        </div>
                                        {/* Col 3: Scheme Filter */}
                                        <div className="col-3">
                                          <select
                                            className="form-select"
                                            value={
                                              this.state.selectedScheme || ""
                                            }
                                            onChange={(e) =>
                                              this.handleSchemeSelect(e)
                                            }
                                          >
                                            <option value="">
                                              Select Scheme
                                            </option>
                                            {Array.isArray(
                                              this.state.filteredCycleList,
                                            ) &&
                                              [
                                                ...new Map(
                                                  this.state.filteredCycleList.map(
                                                    (item) => [
                                                      String(item.scheme_id),
                                                      item,
                                                    ],
                                                  ),
                                                ).values(),
                                              ].map((scheme) => (
                                                <option
                                                  key={scheme.scheme_id}
                                                  value={String(
                                                    scheme.scheme_id,
                                                  )}
                                                >
                                                  {scheme.scheme_name}
                                                </option>
                                              ))}
                                          </select>
                                        </div>

                                        {/* Col 4: Cycle Filter (if scheme selected) OR Scheme Count */}
                                        <div className="col-3">
                                          {this.state.showCycleFilter ? (
                                            <select
                                              className="form-select"
                                              value={
                                                this.state.selectedCycle || ""
                                              }
                                              onChange={(e) =>
                                                this.handleCycleSelect(e)
                                              }
                                            >
                                              <option value="">
                                                Select Cycle
                                              </option>
                                              {this.state.filteredCycleOptions.map(
                                                (cycle) => (
                                                  <option
                                                    key={cycle.id}
                                                    value={cycle.id}
                                                  >
                                                    Cycle {cycle.cycle_no}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          ) : (
                                            <select
                                              className="form-select"
                                              value={
                                                this.state.selectedSchemeCount
                                              }
                                              onChange={
                                                this.handleSchemeCountChange
                                              }
                                            >
                                              <option value="">
                                                Scheme Count
                                              </option>
                                              {schemeCountOptions.map(
                                                (count) => (
                                                  <option
                                                    key={count}
                                                    value={count}
                                                  >
                                                    {count}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          )}
                                        </div>
                                      </div>

                                      {/* Row 2: Scheme Count (only when Cycle Filter is visible) */}
                                      {this.state.showCycleFilter && (
                                        <div className="row align-items-center">
                                          <div className="col-3">
                                            <select
                                              className="form-select"
                                              value={
                                                this.state.selectedSchemeCount
                                              }
                                              onChange={
                                                this.handleSchemeCountChange
                                              }
                                            >
                                              <option value="">
                                                Scheme Count
                                              </option>
                                              {schemeCountOptions.map(
                                                (count) => (
                                                  <option
                                                    key={count}
                                                    value={count}
                                                  >
                                                    {count}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-2 mt-3"></Row>
                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    {console.log("TABLE BLOCK RENDERED")}
                                    <BootstrapTable
                                      key={`table-${this.state.filteredLabs.length}`} // Unique key for each data update
                                      keyField="id"
                                      data={this.state.filteredLabs}
                                      columns={this.state.pendingLabListColumns}
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-condensed"
                                      }
                                      bordered={false}
                                      striped={true}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                      rowClasses={(row, rowIndex) =>
                                        rowIndex % 2 === 0 ? "row-a" : "row-b"
                                      }
                                      // rowStyle={(row, rowIndex) => {
                                      //   const isPart =
                                      //     row.payment_settlement
                                      //       ?.toString()
                                      //       .toLowerCase() === "part";
                                      //   return isPart
                                      //     ? {
                                      //         backgroundColor: "#ff7f7f",
                                      //         color: "black",
                                      //       } // Entire row #ff7f7f
                                      //     : {};
                                      // }}
                                    />
                                    <Modal
                                      isOpen={this.state.LabModal}
                                      className={this.props.className}
                                      onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleLabModal}
                                        tag="h4"
                                      >
                                        <strong>
                                          {this.state.name || "Lab Details"}
                                        </strong>
                                      </ModalHeader>

                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      UserName
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.email}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Lab Code
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.lab_code
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Password
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .password_foradmins
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Shipping Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .shipping_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Billing Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .billing_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.showSchemeModal}
                                      toggle={this.handleSchemeModalClose}
                                      size="lg"
                                    >
                                      <ModalHeader
                                        toggle={this.handleSchemeModalClose}
                                      >
                                        {this.state.selectedParticipant?.name ||
                                          "Participant"}{" "}
                                        — Purchased Schemes
                                      </ModalHeader>
                                      <ModalBody>
                                        {this.state.selectedSchemes &&
                                        this.state.selectedSchemes.length >
                                          0 ? (
                                          <div className="table-responsive">
                                            <table className="table table-bordered table-hover align-middle mb-0">
                                              <thead
                                                style={{
                                                  backgroundColor: "#a6d4ff",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <tr>
                                                  <th>Scheme Name</th>
                                                  <th>Cycle No</th>
                                                  <th>Cycle Status</th>
                                                  <th>Issued Rounds</th>
                                                  <th>Payment Settlement</th>
                                                  <th>Payment Status</th>
                                                  <th>COP</th> {/* ✅ NEW */}
                                                  <th>COA</th> {/* ✅ NEW */}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.selectedSchemes.map(
                                                  (scheme, i) => {
                                                    const isPart =
                                                      this.state.selectedParticipant?.payment_settlement
                                                        ?.toString()
                                                        .toLowerCase() ===
                                                      "part";

                                                    return (
                                                      <tr
                                                        key={i}
                                                        style={{
                                                          backgroundColor:
                                                            isPart
                                                              ? "#ff7f7f"
                                                              : "#e0e0e0",
                                                          color: isPart
                                                            ? "#c20505ff"
                                                            : "black",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        <td>
                                                          {scheme.scheme_name ||
                                                            "–"}
                                                        </td>
                                                        <td>
                                                          {scheme.cycle_no ||
                                                            "–"}
                                                        </td>
                                                        <td>
                                                          <span
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                              color:
                                                                scheme.cycle_status?.toLowerCase() ===
                                                                "active"
                                                                  ? "green"
                                                                  : "red",
                                                            }}
                                                          >
                                                            {scheme.cycle_status ||
                                                              "–"}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          {scheme.round_numbers ||
                                                            "–"}
                                                        </td>
                                                        <td>
                                                          <span
                                                            style={{
                                                              color: isPart
                                                                ? "#c20505ff"
                                                                : "black",
                                                            }}
                                                          >
                                                            {this.state
                                                              .selectedParticipant
                                                              ?.payment_settlement ||
                                                              "–"}
                                                            {isPart &&
                                                              this.state
                                                                .selectedParticipant
                                                                ?.remaining_amount && (
                                                                <div
                                                                  style={{
                                                                    fontSize:
                                                                      "0.85em",
                                                                    color:
                                                                      "#c20505ff",
                                                                  }}
                                                                >
                                                                  Remaining:{" "}
                                                                  {Number(
                                                                    this.state
                                                                      .selectedParticipant
                                                                      .remaining_amount,
                                                                  ).toLocaleString() ||
                                                                    "–"}
                                                                </div>
                                                              )}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          {(() => {
                                                            const reconcileStatus =
                                                              this.state.selectedParticipant?.payment_reconcile_status?.toLowerCase();
                                                            const isVerified =
                                                              reconcileStatus ===
                                                              "verified";
                                                            return (
                                                              <span
                                                                style={{
                                                                  color:
                                                                    isVerified
                                                                      ? "green"
                                                                      : "red",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {this.state
                                                                  .selectedParticipant
                                                                  ?.payment_status ||
                                                                  "–"}
                                                              </span>
                                                            );
                                                          })()}
                                                        </td>

                                                        {/* ✅ COP column */}

                                                        <td>
                                                          {(() => {
                                                            const isVerified =
                                                              this.state.selectedParticipant?.payment_reconcile_status?.toLowerCase() ===
                                                              "verified";
                                                            const organization_name =
                                                              this.state
                                                                .organization_name;
                                                            const participantId =
                                                              this.state
                                                                .selectedParticipant
                                                                ?.id;

                                                            if (isVerified) {
                                                              return (
                                                                <span
                                                                  className="text-primary"
                                                                  style={{
                                                                    textDecoration:
                                                                      "underline",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() => {
                                                                    this.props.history.push(
                                                                      `/${organization_name}/${participantId}/certificate?scheme_id=${scheme.scheme_id}&cycle_id=${scheme.cycle_id}`,
                                                                    );
                                                                  }}
                                                                >
                                                                  View
                                                                </span>
                                                              );
                                                            }
                                                            return (
                                                              <span className="text-muted">
                                                                -
                                                              </span>
                                                            );
                                                          })()}
                                                        </td>

                                                        {/* ✅ COA column */}
                                                        <td>
                                                          {(() => {
                                                            const isEligible =
                                                              scheme.coa_status ===
                                                              "Eligible";
                                                            const organization_name =
                                                              this.state
                                                                .organization_name;
                                                            const participantId =
                                                              this.state
                                                                .selectedParticipant
                                                                ?.id;

                                                            if (isEligible) {
                                                              return (
                                                                <span
                                                                  className="text-success"
                                                                  style={{
                                                                    textDecoration:
                                                                      "underline",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() => {
                                                                    this.props.history.push(
                                                                      `/${organization_name}/${participantId}/certificate_of_achievement?scheme_id=${scheme.scheme_id}&cycle_id=${scheme.cycle_id}`,
                                                                    );
                                                                  }}
                                                                >
                                                                  View
                                                                </span>
                                                              );
                                                            }
                                                            return (
                                                              <span className="text-muted">
                                                                -
                                                              </span>
                                                            );
                                                          })()}
                                                        </td>
                                                      </tr>
                                                    );
                                                  },
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          <p className="text-center">
                                            No schemes found.
                                          </p>
                                        )}
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.MarketerModal}
                                      className={this.props.className}
                                      onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleMarketerModal}
                                        tag="h4"
                                      >
                                        <span></span>
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Name
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.marketer_name
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      City
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.city}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      District
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.district
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.PatientModal}
                                      className={this.props.className}
                                      onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.togglePatientModal}
                                        tag="h4"
                                      >
                                        <span></span>
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Email
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.email}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Mobile No.
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-6">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .landline_registered_by
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                  {/* /////////////////// */}
                                                  <div className="col-md-6">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .payment_status
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                  <div className="col-md-3">
                                                    <button
                                                      type="button"
                                                      className="btn btn-secondary"
                                                      onClick={() => {
                                                        navigator.clipboard.writeText(
                                                          this.state
                                                            .payment_status,
                                                        );
                                                        this.setState({
                                                          btnText: "Copied",
                                                        });
                                                      }}
                                                    >
                                                      {this.state.btnText}
                                                    </button>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>

                                    <Modal
                                      isOpen={this.state.isPaymentModalOpen}
                                      toggle={this.togglePaymentModal}
                                      className={this.props.className}
                                    >
                                      <ModalHeader
                                        toggle={this.togglePaymentModal}
                                      >
                                        Payment for{" "}
                                        {this.state.selectedParticipant?.name ||
                                          "Unknown"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={{
                                            photo: "",
                                            participant:
                                              this.state.selectedParticipant
                                                ?.id || "",
                                            paydate: "",
                                            payment_status: "", // No default
                                            payment_settlement: "",
                                            // is_active: false,      // default inactive
                                            paymentmethod: "",
                                            discountAmount: "",
                                            taxDeduction: "",
                                            scheme: [],
                                            part_payment_amount: "",
                                            remaining_amount: "",
                                            purchase_order_copy: "",
                                            price: "",
                                            discount: 0,
                                            receivedby: "",
                                            added_by: localStorage.getItem(
                                              "authUser",
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser",
                                                  ),
                                                ).user_id
                                              : "",
                                          }}
                                          validationSchema={Yup.object().shape({
                                            participant: Yup.string().required(
                                              "Participant is required",
                                            ),
                                            taxDeduction:
                                              Yup.number().nullable(),
                                            discountAmount: Yup.number()
                                              .nullable()
                                              .when("payment_status", {
                                                is: () => true, // always true, so no conditional effect
                                                then: Yup.number()
                                                  .nullable()
                                                  .notRequired()
                                                  .transform(
                                                    (value, originalValue) =>
                                                      originalValue === ""
                                                        ? null
                                                        : value,
                                                  ),
                                                otherwise: Yup.number()
                                                  .nullable()
                                                  .notRequired()
                                                  .transform(
                                                    (value, originalValue) =>
                                                      originalValue === ""
                                                        ? null
                                                        : value,
                                                  ),
                                              }),
                                            purchase_order_copy:
                                              Yup.mixed().when(
                                                "payment_status",
                                                {
                                                  is: (val) =>
                                                    val !==
                                                    "Payment In process", // required only if NOT "Payment In process"
                                                  then: Yup.mixed().required(
                                                    "Upload copy of purchase order is required",
                                                  ),
                                                  otherwise:
                                                    Yup.mixed().notRequired(),
                                                },
                                              ),
                                            price: Yup.string().when(
                                              "discount",
                                              {
                                                is: (discount) =>
                                                  discount === 100,
                                                then: Yup.string()
                                                  .test(
                                                    "price-zero-if-100-discount",
                                                    "Price must be 0 if discount is 100%",
                                                    (value) =>
                                                      parseFloat(value) === 0,
                                                  )
                                                  .required(
                                                    "Price is required",
                                                  ),
                                                otherwise:
                                                  Yup.string().required(
                                                    "Price is required",
                                                  ),
                                              },
                                            ),

                                            payment_status: Yup.string().when(
                                              ["discount", "price"],
                                              {
                                                is: (discount, price) =>
                                                  !(
                                                    discount === 100 &&
                                                    parseFloat(price) === 0
                                                  ),
                                                then: Yup.string().required(
                                                  "Payment status is required",
                                                ),
                                                otherwise:
                                                  Yup.string().notRequired(),
                                              },
                                            ),

                                            paydate: Yup.string().when(
                                              [
                                                "discount",
                                                "price",
                                                "payment_status",
                                              ],
                                              {
                                                is: (
                                                  discount,
                                                  price,
                                                  payment_status,
                                                ) =>
                                                  !(
                                                    discount === 100 &&
                                                    parseFloat(price) === 0
                                                  ) &&
                                                  payment_status !==
                                                    "Payment In process",
                                                then: Yup.string().required(
                                                  "Date is required",
                                                ),
                                                otherwise:
                                                  Yup.string().notRequired(),
                                              },
                                            ),

                                            photo: Yup.mixed().when(
                                              [
                                                "discount",
                                                "price",
                                                "payment_status",
                                              ],
                                              {
                                                is: (
                                                  discount,
                                                  price,
                                                  payment_status,
                                                ) =>
                                                  !(
                                                    discount === 100 &&
                                                    parseFloat(price) === 0
                                                  ) &&
                                                  payment_status !==
                                                    "Payment In process",
                                                then: Yup.mixed()
                                                  .required(
                                                    "Deposit Slip is required",
                                                  )
                                                  .test(
                                                    "fileSize",
                                                    "File too large",
                                                    (value) =>
                                                      !value ||
                                                      (value &&
                                                        value.size <=
                                                          2 * 1024 * 1024),
                                                  )
                                                  .test(
                                                    "fileType",
                                                    "Unsupported file format",
                                                    (value) =>
                                                      !value ||
                                                      (value &&
                                                        [
                                                          "image/jpeg",
                                                          "image/png",
                                                          "image/jpg",
                                                          "application/pdf",
                                                        ].includes(value.type)),
                                                  ),
                                                otherwise:
                                                  Yup.mixed().notRequired(),
                                              },
                                            ),

                                            receivedby: Yup.string().when(
                                              [
                                                "discount",
                                                "price",
                                                "payment_status",
                                              ],
                                              {
                                                is: (
                                                  discount,
                                                  price,
                                                  payment_status,
                                                ) =>
                                                  !(
                                                    discount === 100 &&
                                                    parseFloat(price) === 0
                                                  ) &&
                                                  payment_status !==
                                                    "Payment In process",
                                                then: Yup.string().required(
                                                  "Received By is required",
                                                ),
                                                otherwise:
                                                  Yup.string().notRequired(),
                                              },
                                            ),

                                            paymentmethod: Yup.string().when(
                                              [
                                                "discount",
                                                "price",
                                                "payment_status",
                                              ],
                                              {
                                                is: (
                                                  discount,
                                                  price,
                                                  payment_status,
                                                ) =>
                                                  !(
                                                    discount === 100 &&
                                                    parseFloat(price) === 0
                                                  ) &&
                                                  payment_status !==
                                                    "Payment In process",
                                                then: Yup.string().required(
                                                  "Payment Method is required",
                                                ),
                                                otherwise:
                                                  Yup.string().notRequired(),
                                              },
                                            ),
                                            purchase_order_copy:
                                              Yup.mixed().when(
                                                "payment_status",
                                                {
                                                  is: (val) =>
                                                    val ===
                                                    "Payment In process", // <-- Make it required if status is "Payment In process"
                                                  then: Yup.mixed().required(
                                                    "Upload Copy of Purchase Order is required",
                                                  ),
                                                  otherwise:
                                                    Yup.mixed().notRequired(),
                                                },
                                              ),

                                            discount: Yup.number()
                                              .nullable()
                                              .notRequired()
                                              .transform(
                                                (value, originalValue) =>
                                                  originalValue === ""
                                                    ? null
                                                    : value,
                                              )
                                              .min(
                                                -1000,
                                                "Discount cannot be less than -1000%",
                                              )
                                              .max(
                                                1000,
                                                "Discount cannot be more than 1000%",
                                              ),
                                          })}
                                          onSubmit={async (
                                            values,
                                            { setSubmitting, resetForm },
                                          ) => {
                                            const userId = localStorage.getItem(
                                              "authUser",
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser",
                                                  ),
                                                ).user_id
                                              : "";
                                            const roundedPrice = Math.round(
                                              parseFloat(values.price),
                                            );
                                            const safePaydate =
                                              values.paydate &&
                                              values.paydate.trim() !== ""
                                                ? values.paydate
                                                : null;
                                            const AddPayment = {
                                              participant: values.participant,
                                              scheme: values.scheme,
                                              price: roundedPrice,
                                              payment_status:
                                                values.payment_status,

                                              payment_settlement:
                                                values.payment_settlement,
                                              // is_active: values.is_active, // Pass this to backend
                                              discount: values.discount,
                                              discountAmount:
                                                values.discountAmount,
                                              paydate: safePaydate,
                                              taxDeduction: values.taxDeduction,
                                              priceBeforeDiscount:
                                                values.priceBeforeDiscount,
                                              part_payment_amount:
                                                values.part_payment_amount,
                                              photo: values.photo,
                                              purchase_order_copy:
                                                values.purchase_order_copy,
                                              receivedby: values.receivedby,
                                              paymentmethod:
                                                values.paymentmethod,
                                              added_by: userId,
                                            };
                                            // 👉 Place this block immediately after the object above:
                                            if (values.discount === 100) {
                                              // Remove all unnecessary fields if discount is 100%
                                              delete AddPayment.remaining_amount;
                                              delete AddPayment.paydate;
                                              delete AddPayment.photo;
                                              delete AddPayment.payment_status;
                                              delete AddPayment.receivedby;
                                              delete AddPayment.paymentmethod;
                                              delete AddPayment.discountAmount;
                                              delete AddPayment.payment_settlement;
                                            } else {
                                              // Provide fallbacks if values are missing
                                              if (
                                                values.payment_settlement ===
                                                "Part"
                                              ) {
                                                AddPayment.remaining_amount =
                                                  values.remaining_amount ?? 0;
                                              }
                                              AddPayment.paydate =
                                                values.paydate ?? null;
                                              AddPayment.photo =
                                                values.photo ?? null;
                                              AddPayment.payment_status =
                                                values.payment_status ?? null;
                                              AddPayment.receivedby =
                                                values.receivedby ?? null;
                                              AddPayment.paymentmethod =
                                                values.paymentmethod ?? null;
                                            }

                                            // Conditionally add remaining_amount only if payment_settlement === 'part'
                                            if (
                                              values.payment_settlement ===
                                              "Part"
                                            ) {
                                              AddPayment.remaining_amount =
                                                values.remaining_amount || 0; // Or whatever logic you want for default
                                            }

                                            try {
                                              await this.props.onAddNewPayment(
                                                userId,
                                                AddPayment,
                                              );
                                              await this.props.onGetPendingLabs(
                                                this.state.user_id,
                                              ); //payment modal
                                              this.setState({
                                                isPaymentModalOpen: false,
                                              }); // Close modal here
                                              resetForm();
                                              this.displaySuccessMessage(
                                                "Payment added successfully!",
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Error adding payment:",
                                                error,
                                              );
                                            }
                                            setTimeout(() => {
                                              this.props.onGetPendingLabs(
                                                this.state.user_id,
                                              );
                                            }, 1000);
                                            setTimeout(() => {
                                              this.props.ongetcyclelist(
                                                this.state.user_id,
                                              );
                                            }, 1000);
                                            this.setState({
                                              isPaymentModalOpen: false,
                                            });
                                            setSubmitting(false);
                                          }}
                                        >
                                          {({
                                            values,
                                            errors,
                                            touched,
                                            setFieldValue,
                                            submitForm, // <-- add this
                                          }) => {
                                            const handleSchemeChange = (
                                              selectedOptions,
                                            ) => {
                                              const selectedValues =
                                                selectedOptions
                                                  ? selectedOptions.map(
                                                      (option) => option.value,
                                                    )
                                                  : [];
                                              setFieldValue(
                                                "scheme",
                                                selectedValues,
                                              );

                                              const totalPrice =
                                                selectedValues.reduce(
                                                  (sum, schemeId) => {
                                                    const scheme =
                                                      CycleList.find(
                                                        (s) =>
                                                          s.id === schemeId,
                                                      );
                                                    return (
                                                      sum +
                                                      (scheme
                                                        ? parseFloat(
                                                            scheme.price,
                                                          )
                                                        : 0)
                                                    );
                                                  },
                                                  0,
                                                );

                                              // Set priceBeforeDiscount only once when schemes are selected
                                              if (
                                                !values.priceBeforeDiscount ||
                                                values.scheme.length === 0
                                              ) {
                                                setFieldValue(
                                                  "priceBeforeDiscount",
                                                  totalPrice.toFixed(2),
                                                );
                                              }

                                              // Update the price to reflect the total (will be modified later by discount)
                                              setFieldValue(
                                                "price",
                                                totalPrice.toFixed(2),
                                              );
                                            };

                                            const handleDiscountChange = (
                                              e,
                                            ) => {
                                              let discountValue = parseFloat(
                                                e.target.value,
                                              );
                                              if (
                                                isNaN(discountValue) ||
                                                discountValue < 0
                                              )
                                                discountValue = 0;

                                              setFieldValue(
                                                "discount",
                                                discountValue,
                                              );

                                              const priceBeforeDiscount =
                                                parseFloat(
                                                  values.priceBeforeDiscount,
                                                ) || 0;

                                              // Apply discount
                                              const discountedPrice =
                                                priceBeforeDiscount *
                                                (1 - discountValue / 100);
                                              const discountAmount =
                                                priceBeforeDiscount -
                                                discountedPrice;

                                              // Apply tax deduction if exists
                                              const taxDeduction =
                                                parseFloat(
                                                  values.taxDeduction,
                                                ) || 0;
                                              const finalPrice =
                                                discountedPrice *
                                                (1 - taxDeduction / 100);

                                              setFieldValue(
                                                "discountAmount",
                                                discountAmount.toFixed(2),
                                              );
                                              setFieldValue(
                                                "price",
                                                finalPrice.toFixed(2),
                                              );

                                              if (discountValue === 100) {
                                                submitForm();
                                              }
                                            };

                                            const handleTaxChange = (e) => {
                                              let taxDeduction = parseFloat(
                                                e.target.value,
                                              );
                                              if (
                                                isNaN(taxDeduction) ||
                                                taxDeduction < 0
                                              )
                                                taxDeduction = 0;
                                              if (taxDeduction > 100)
                                                taxDeduction = 100;

                                              setFieldValue(
                                                "taxDeduction",
                                                taxDeduction,
                                              );

                                              const priceBeforeDiscount =
                                                parseFloat(
                                                  values.priceBeforeDiscount,
                                                ) || 0;
                                              const discount =
                                                parseFloat(values.discount) ||
                                                0;

                                              // Apply discount
                                              const discountedPrice =
                                                priceBeforeDiscount *
                                                (1 - discount / 100);

                                              // Apply tax deduction
                                              const finalPrice =
                                                discountedPrice *
                                                (1 - taxDeduction / 100);

                                              setFieldValue(
                                                "price",
                                                finalPrice.toFixed(2),
                                              );
                                            };

                                            return (
                                              <Form>
                                                {errors.successMessage && (
                                                  <Alert color="success">
                                                    {errors.successMessage}
                                                  </Alert>
                                                )}
                                                <Row>
                                                  <Col>
                                                    <Label>Scheme</Label>
                                                    <Select
                                                      name="scheme"
                                                      isMulti
                                                      options={schemeOptions}
                                                      className={
                                                        errors.scheme &&
                                                        touched.scheme
                                                          ? "is-invalid"
                                                          : ""
                                                      }
                                                      value={schemeOptions.filter(
                                                        (option) =>
                                                          values.scheme.includes(
                                                            option.value,
                                                          ),
                                                      )}
                                                      onChange={(
                                                        selectedOptions,
                                                      ) => {
                                                        const selectedValues =
                                                          selectedOptions
                                                            ? selectedOptions.map(
                                                                (option) =>
                                                                  option.value,
                                                              )
                                                            : [];

                                                        setFieldValue(
                                                          "scheme",
                                                          selectedValues,
                                                        );

                                                        console.log(
                                                          "Selected Scheme IDs:",
                                                          selectedValues,
                                                        ); // Debugging

                                                        const totalPrice =
                                                          selectedValues.reduce(
                                                            (
                                                              sum,
                                                              combinedId,
                                                            ) => {
                                                              const [
                                                                _,
                                                                cycleId,
                                                              ] = combinedId
                                                                .split("-")
                                                                .map(Number); // extract cycleId
                                                              const scheme =
                                                                this.props.CycleList.find(
                                                                  (s) =>
                                                                    s.id ===
                                                                    cycleId,
                                                                );
                                                              return (
                                                                sum +
                                                                (scheme
                                                                  ? parseFloat(
                                                                      (
                                                                        scheme.price ||
                                                                        "0"
                                                                      ).replace(
                                                                        /,/g,
                                                                        "",
                                                                      ),
                                                                    )
                                                                  : 0)
                                                              );
                                                            },
                                                            0,
                                                          );

                                                        console.log(
                                                          "Total Price:",
                                                          totalPrice,
                                                        ); // Debugging

                                                        setFieldValue(
                                                          "priceBeforeDiscount",
                                                          totalPrice.toFixed(2),
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          totalPrice.toFixed(2),
                                                        );
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col>
                                                    <div className="mb-3">
                                                      <Label
                                                        htmlFor="priceBeforeDiscount"
                                                        className="form-label"
                                                      >
                                                        Payable
                                                      </Label>
                                                      <Field name="priceBeforeDiscount">
                                                        {({ field }) => (
                                                          <input
                                                            {...field}
                                                            type="text"
                                                            className="form-control"
                                                            value={new Intl.NumberFormat(
                                                              "en-PK",
                                                            ).format(
                                                              values.priceBeforeDiscount ||
                                                                0,
                                                            )}
                                                            readOnly
                                                            style={{
                                                              backgroundColor:
                                                                "#e9ecef",
                                                            }}
                                                          />
                                                        )}
                                                      </Field>
                                                      <ErrorMessage
                                                        name="priceBeforeDiscount"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>

                                                <Row>
                                                  <Col md={6}>
                                                    <Label>
                                                      Discount in (%)
                                                    </Label>
                                                    <Field name="discount">
                                                      {({ field }) => (
                                                        <input
                                                          {...field}
                                                          type="text"
                                                          className="form-control"
                                                          onChange={(e) => {
                                                            const discountPercent =
                                                              parseFloat(
                                                                e.target.value,
                                                              );
                                                            setFieldValue(
                                                              "discount",
                                                              e.target.value,
                                                            );

                                                            const payable =
                                                              parseFloat(
                                                                values.priceBeforeDiscount,
                                                              ) || 0;
                                                            if (
                                                              !isNaN(
                                                                discountPercent,
                                                              )
                                                            ) {
                                                              const discountAmount =
                                                                (payable *
                                                                  discountPercent) /
                                                                100;
                                                              setFieldValue(
                                                                "discountAmount",
                                                                discountAmount.toFixed(
                                                                  2,
                                                                ),
                                                              );
                                                              const tax =
                                                                parseFloat(
                                                                  values.taxDeduction,
                                                                ) || 0;
                                                              const finalPrice =
                                                                payable -
                                                                discountAmount -
                                                                tax;
                                                              setFieldValue(
                                                                "price",
                                                                finalPrice.toFixed(
                                                                  2,
                                                                ),
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      )}
                                                    </Field>
                                                    <ErrorMessage
                                                      name="discount"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>

                                                  <Col md={6}>
                                                    <Label>
                                                      Discount Amount (Rs)
                                                    </Label>
                                                    <Field name="discountAmount">
                                                      {({ field }) => (
                                                        <input
                                                          {...field}
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            field.value || ""
                                                          } // Ensures controlled input
                                                          onChange={(e) => {
                                                            const discountAmount =
                                                              parseFloat(
                                                                e.target.value,
                                                              );
                                                            setFieldValue(
                                                              "discountAmount",
                                                              e.target.value,
                                                            );

                                                            const payable =
                                                              parseFloat(
                                                                values.priceBeforeDiscount,
                                                              ) || 0;
                                                            if (
                                                              !isNaN(
                                                                discountAmount,
                                                              ) &&
                                                              payable > 0
                                                            ) {
                                                              const percent =
                                                                (discountAmount /
                                                                  payable) *
                                                                100;
                                                              setFieldValue(
                                                                "discount",
                                                                percent.toFixed(
                                                                  2,
                                                                ),
                                                              );
                                                              const tax =
                                                                parseFloat(
                                                                  values.taxDeduction,
                                                                ) || 0;
                                                              const finalPrice =
                                                                payable -
                                                                discountAmount -
                                                                tax;
                                                              setFieldValue(
                                                                "price",
                                                                finalPrice.toFixed(
                                                                  2,
                                                                ),
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      )}
                                                    </Field>

                                                    <ErrorMessage
                                                      name="discountAmount"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>
                                                </Row>

                                                <Row>
                                                  <Col>
                                                    <Label>
                                                      Tax Deduction Amount
                                                    </Label>
                                                    <Field name="taxDeduction">
                                                      {({ field }) => (
                                                        <input
                                                          {...field}
                                                          type="text"
                                                          className="form-control"
                                                          placeholder="Enter tax deduction amount"
                                                          onChange={(e) => {
                                                            const tax =
                                                              parseFloat(
                                                                e.target.value,
                                                              );
                                                            setFieldValue(
                                                              "taxDeduction",
                                                              e.target.value,
                                                            );

                                                            const payable =
                                                              parseFloat(
                                                                values.priceBeforeDiscount,
                                                              ) || 0;
                                                            const discount =
                                                              parseFloat(
                                                                values.discountAmount,
                                                              ) || 0;
                                                            if (!isNaN(tax)) {
                                                              const finalPrice =
                                                                payable -
                                                                discount -
                                                                tax;
                                                              setFieldValue(
                                                                "price",
                                                                finalPrice.toFixed(
                                                                  2,
                                                                ),
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      )}
                                                    </Field>
                                                    <ErrorMessage
                                                      name="taxDeduction"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col>
                                                    <Label>
                                                      Payment Status
                                                    </Label>
                                                    <Select
                                                      name="payment_status"
                                                      options={[
                                                        {
                                                          value: "Paid",
                                                          label: "Paid",
                                                        },
                                                        {
                                                          value:
                                                            "Payment In process",
                                                          label:
                                                            "Payment In process",
                                                        },
                                                      ]}
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        const status =
                                                          selectedOption?.value ||
                                                          "";
                                                        setFieldValue(
                                                          "payment_status",
                                                          status,
                                                        );

                                                        if (
                                                          status === "Paid" ||
                                                          status ===
                                                            "Payment In process"
                                                        ) {
                                                          setFieldValue(
                                                            "is_active",
                                                            true,
                                                          );
                                                        }
                                                      }}
                                                      value={
                                                        values.payment_status
                                                          ? {
                                                              value:
                                                                values.payment_status,
                                                              label:
                                                                values.payment_status,
                                                            }
                                                          : null
                                                      }
                                                      placeholder="Select"
                                                      className={
                                                        errors.payment_status &&
                                                        touched.payment_status
                                                          ? "is-invalid"
                                                          : ""
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="payment_status"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>
                                                  {values.payment_status ===
                                                    "Payment In process" && (
                                                    <div className="form-group">
                                                      <label>
                                                        Upload Copy of Purchase
                                                        Order
                                                      </label>
                                                      <input
                                                        type="file"
                                                        name="purchase_order_copy"
                                                        onChange={(event) =>
                                                          setFieldValue(
                                                            "purchase_order_copy",
                                                            event.currentTarget
                                                              .files[0],
                                                          )
                                                        }
                                                        className="form-control"
                                                      />
                                                      {errors.purchase_order_copy &&
                                                        touched.purchase_order_copy && (
                                                          <div className="text-danger">
                                                            {
                                                              errors.purchase_order_copy
                                                            }
                                                          </div>
                                                        )}
                                                    </div>
                                                  )}
                                                </Row>
                                                {values.payment_status ===
                                                  "Paid" && (
                                                  <>
                                                    <Row>
                                                      <Col>
                                                        <div className="mb-3">
                                                          <Label
                                                            htmlFor="price"
                                                            className="form-label"
                                                          >
                                                            Payable after
                                                            Discount & Tax
                                                            Deduction
                                                          </Label>
                                                          <Field name="price">
                                                            {({ field }) => (
                                                              <input
                                                                {...field}
                                                                type="text"
                                                                className="form-control"
                                                                value={new Intl.NumberFormat(
                                                                  "en-PK",
                                                                  {
                                                                    style:
                                                                      "currency",
                                                                    currency:
                                                                      "PKR",
                                                                  },
                                                                ).format(
                                                                  values.price ||
                                                                    0,
                                                                )}
                                                                readOnly
                                                                style={{
                                                                  backgroundColor:
                                                                    "#e9ecef",
                                                                }}
                                                              />
                                                            )}
                                                          </Field>
                                                          <ErrorMessage
                                                            name="price"
                                                            component="div"
                                                            className="invalid-feedback"
                                                          />
                                                        </div>
                                                      </Col>
                                                    </Row>

                                                    <Col>
                                                      <Label>
                                                        Payment Settlement
                                                      </Label>
                                                      <Select
                                                        name="payment_settlement"
                                                        options={[
                                                          {
                                                            value: "Full",
                                                            label: "Full",
                                                          },
                                                          {
                                                            value: "Part",
                                                            label: "Part",
                                                          },
                                                        ]}
                                                        onChange={(
                                                          selectedOption,
                                                        ) => {
                                                          const settlement =
                                                            selectedOption?.value ||
                                                            "";
                                                          setFieldValue(
                                                            "payment_settlement",
                                                            settlement,
                                                          );
                                                          if (
                                                            settlement ===
                                                              "Full" ||
                                                            settlement ===
                                                              "Part"
                                                          ) {
                                                            setFieldValue(
                                                              "is_active",
                                                              true,
                                                            );
                                                          }
                                                        }}
                                                        value={
                                                          values.payment_settlement
                                                            ? {
                                                                value:
                                                                  values.payment_settlement,
                                                                label:
                                                                  values.payment_settlement,
                                                              }
                                                            : null
                                                        }
                                                        placeholder="Select"
                                                        className={
                                                          errors.payment_settlement &&
                                                          touched.payment_settlement
                                                            ? "is-invalid"
                                                            : ""
                                                        }
                                                      />
                                                      <ErrorMessage
                                                        name="payment_settlement"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>

                                                    {values.payment_settlement ===
                                                      "Part" && (
                                                      <>
                                                        <Col className="mt-3">
                                                          <Label>
                                                            Part Payment Amount
                                                          </Label>
                                                          <Field name="part_payment_amount">
                                                            {({ field }) => (
                                                              <input
                                                                {...field}
                                                                type="number"
                                                                className={
                                                                  errors.part_payment_amount &&
                                                                  touched.part_payment_amount
                                                                    ? "form-control is-invalid"
                                                                    : "form-control"
                                                                }
                                                                value={
                                                                  field.value ===
                                                                    undefined ||
                                                                  field.value ===
                                                                    null
                                                                    ? ""
                                                                    : field.value
                                                                }
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  const partAmount =
                                                                    parseFloat(
                                                                      e.target
                                                                        .value,
                                                                    ) || 0;
                                                                  const totalAmount =
                                                                    parseFloat(
                                                                      values.price,
                                                                    ) || 0;
                                                                  const remaining =
                                                                    totalAmount -
                                                                    partAmount;
                                                                  setFieldValue(
                                                                    "part_payment_amount",
                                                                    e.target
                                                                      .value,
                                                                  );
                                                                  setFieldValue(
                                                                    "remaining_amount",
                                                                    remaining >=
                                                                      0
                                                                      ? remaining
                                                                      : 0,
                                                                  );
                                                                }}
                                                              />
                                                            )}
                                                          </Field>
                                                          <ErrorMessage
                                                            name="part_payment_amount"
                                                            component="div"
                                                            className="invalid-feedback"
                                                          />
                                                        </Col>

                                                        <Col className="mt-3">
                                                          <Label>
                                                            Remaining Amount
                                                          </Label>
                                                          <Field
                                                            name="remaining_amount"
                                                            type="number"
                                                            disabled
                                                            className="form-control"
                                                          />
                                                        </Col>
                                                      </>
                                                    )}
                                                    <Row>
                                                      <Col>
                                                        <Label>Pay Date</Label>
                                                        <Field
                                                          name="paydate"
                                                          type="date"
                                                          className="form-control"
                                                        />
                                                        <ErrorMessage
                                                          name="paydate"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </Col>
                                                    </Row>

                                                    <Row>
                                                      <Col>
                                                        <Label>Pay Copy</Label>
                                                        <Input
                                                          id="formFile"
                                                          name="photo"
                                                          type="file"
                                                          multiple={false}
                                                          accept=".jpg,.jpeg,.png,.pdf"
                                                          onChange={(event) =>
                                                            this.handleFileChange(
                                                              event,
                                                              setFieldValue,
                                                            )
                                                          }
                                                          className={
                                                            "form-control" +
                                                            (errors.photo &&
                                                            touched.photo
                                                              ? " is-invalid"
                                                              : "")
                                                          }
                                                        />
                                                        <small
                                                          style={{
                                                            color: "#007bff",
                                                          }}
                                                        >
                                                          Only JPEG, PNG, or PDF
                                                          files up to 2MB in
                                                          size are allowed.
                                                        </small>
                                                        <ErrorMessage
                                                          name="photo"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </Col>
                                                    </Row>

                                                    <Row>
                                                      <Col>
                                                        <Label>
                                                          Payment Method
                                                        </Label>
                                                        <Select
                                                          name="paymentmethod"
                                                          options={[
                                                            {
                                                              value: "Online",
                                                              label: "Online",
                                                            },
                                                            {
                                                              value: "Cheque",
                                                              label: "Cheque",
                                                            },
                                                            {
                                                              value: "Cash",
                                                              label: "Cash",
                                                            },
                                                          ]}
                                                          onChange={(
                                                            selectedOption,
                                                          ) =>
                                                            setFieldValue(
                                                              "paymentmethod",
                                                              selectedOption?.value ||
                                                                "",
                                                            )
                                                          }
                                                          value={
                                                            values.paymentmethod
                                                              ? {
                                                                  value:
                                                                    values.paymentmethod,
                                                                  label:
                                                                    values.paymentmethod,
                                                                }
                                                              : null
                                                          }
                                                          className={
                                                            errors.paymentmethod &&
                                                            touched.paymentmethod
                                                              ? "is-invalid"
                                                              : ""
                                                          }
                                                        />
                                                        <ErrorMessage
                                                          name="paymentmethod"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </Col>
                                                    </Row>

                                                    <Row>
                                                      <Col>
                                                        <Label>
                                                          Received By
                                                        </Label>
                                                        <Field
                                                          name="receivedby"
                                                          type="text"
                                                          className="form-control"
                                                        />
                                                        <ErrorMessage
                                                          name="receivedby"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </Col>
                                                    </Row>
                                                  </>
                                                )}

                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    type="submit"
                                                  >
                                                    Save
                                                  </Button>
                                                </ModalFooter>
                                              </Form>
                                            );
                                          }}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PendingLabs.propTypes = {
  match: PropTypes.object,
  AllLabs: PropTypes.array,
  className: PropTypes.any,
  onGetPendingLabs: PropTypes.func,
  onApproveUnapproveLab: PropTypes.func,
  history: PropTypes.any,
  onupdateAllLabs: PropTypes.any,
  onAddNewPayment: PropTypes.func,
  onupdateMembershipStatus: PropTypes.func,
  participantId: PropTypes.func,
  ongetApprovedLabs: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  approvedLabs: PropTypes.array,
  onGetParticipantPayment: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string, // Ensure 'search' is a string
  }).isRequired, // Make it required if always expected

  CycleList: PropTypes.array,
  onGetCityList: PropTypes.func,
  onGetDistrictList: PropTypes.func,
  PaymentSchemeList: PropTypes.array,
  isPaymentModalOpen: PropTypes.array,
  togglePaymentModal: PropTypes.array,
  isMembershipModalOpen: PropTypes.array,
  toggleMembershipModal: PropTypes.array,
  ListCity: PropTypes.array,
  ListDistrict: PropTypes.array,
  ListProvince: PropTypes.array,
  onGetdesignationlist: PropTypes.func,
  ListDesignation: PropTypes.array,
  CSRList: PropTypes.array,
  onGetProvinceList: PropTypes.func,
};
const mapStateToProps = ({
  Account,
  ListCity,
  ListDistrict,
  ListDesignation,
  ListProvince,
  registrationAdmin,
  CycleList,
  AddPayment, // ← renamed from PaymentScheme
}) => {
  console.log("csr_staff from state:", AddPayment?.csr_staff);
  return {
    userID: Account?.userID || null,
    ListCity: ListCity?.ListCity || [],
    ListDistrict: ListDistrict?.ListDistrict || [],
    ListProvince: ListProvince.ListProvince,
    ListDesignation: ListDesignation.ListDesignation,
    AllLabs: registrationAdmin?.AllLabs || [],
    approvedLabs: registrationAdmin?.approvedLabs || [],
    CycleList: CycleList?.CycleList || [],
    PaymentSchemeList: AddPayment?.PaymentSchemeList || [], // ← renamed
    CSRList: AddPayment?.csr_staff || [], // ← renamed
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onApproveUnapproveLab: (data) => dispatch(approveUnapproveLab(data)),
  onGetPendingLabs: (id) => dispatch(getAllLabs(id)),
  onGetInstrumentTypeList: (id) => dispatch(getSchemelist(id)),
  onAddNewType: (id, createUnit) => dispatch(addNewSchemeList(id, createUnit)),
  onUpdateType: (id, methodlist) =>
    dispatch(updateSchemeList({ id, ...methodlist })),
  onupdateAllLabs: (updatedData) => {
    console.log("Dispatching updatedData:", updatedData); // Check if updated data is being passed
    dispatch(updateAllLabs(updatedData));
  },
  onGetCityList: (id) => dispatch(getcitylist(id)),
  onGetDistrictList: (id) => dispatch(getdistrictlist(id)),
  onGetdesignationlist: (id) => dispatch(getdesignationlist(id)),
  onGetProvinceList: (id) => dispatch(getprovincelist(id)),
  onGetParticipantPayment: (id) => dispatch(getParticipantSchemelist(id)),
  ongetApprovedLabs: (id) => dispatch(getApprovedLabs(id)),
  ongetcyclelist: (id) => dispatch(getcyclelist(id)),
  onAddNewPayment: (id, payment) => dispatch(addNewPayment(id, payment)),
  onupdateMembershipStatus: (id, status) => {
    console.log("Updating Membership Status - ID:", id, "Status:", status);
    dispatch(updateMembershipStatus({ id, ...status }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PendingLabs));
